import { useEffect } from "react";

export const useResponsiveLayout = (setIsMobile, setIsFullWidth) => {
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsFullWidth(window.innerWidth >= 1024);
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsMobile, setIsFullWidth]);
};
